import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaEnvelope, FaPhone, FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Success = () => {
  return (
    <div className="min-h-screen relative">
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-blue-900">
          <div className="absolute inset-0 opacity-5" 
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M30 0L0 30h60L30 0zm0 60L60 30H0l30 30z" fill="%23ffffff" fill-opacity="0.4"/%3E%3C/svg%3E")',
                        backgroundSize: '30px 30px' }}>
          </div>
        </div>
      </div>

      <div className="relative z-10">
        <Header />

        <section className="py-20">
          <div className="container mx-auto px-4">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-3xl mx-auto bg-white/10 backdrop-blur-sm rounded-xl p-8 md:p-12 shadow-2xl"
            >
              <div className="text-center mb-8">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ 
                    type: "spring", 
                    stiffness: 260, 
                    damping: 20,
                    delay: 0.2
                  }}
                  className="inline-block mb-6"
                >
                  <div className="w-24 h-24 rounded-full bg-green-500/20 flex items-center justify-center mx-auto">
                    <FaCheckCircle className="text-green-400 text-5xl" />
                  </div>
                </motion.div>
                
                <motion.h1 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.4 }}
                  className="text-3xl md:text-4xl font-bold text-white mb-4"
                >
                  Registration Successful!
                </motion.h1>
                
                <motion.p 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.6 }}
                  className="text-xl text-blue-100 mb-6"
                >
                  Thank you for registering with KSA Academy. We're excited to have you join our community!
                </motion.p>
              </div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                className="bg-white/5 rounded-lg p-6 mb-8"
              >
                <h2 className="text-xl font-semibold text-white mb-4">Next Steps</h2>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <FaEnvelope className="text-blue-400 mt-1 mr-3 flex-shrink-0" />
                    <div>
                      <p className="text-white font-medium">Check Your Email</p>
                      <p className="text-blue-100">We've sent a confirmation email with additional information and next steps.</p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <FaPhone className="text-blue-400 mt-1 mr-3 flex-shrink-0" />
                    <div>
                      <p className="text-white font-medium">Expect a Call</p>
                      <p className="text-blue-100">Our team will contact you within 48 hours to discuss your registration and answer any questions.</p>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <FaCalendarAlt className="text-blue-400 mt-1 mr-3 flex-shrink-0" />
                    <div>
                      <p className="text-white font-medium">Orientation Session</p>
                      <p className="text-blue-100">You'll be invited to an orientation session where you'll meet your coaches and fellow players.</p>
                    </div>
                  </li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1 }}
                className="text-center"
              >
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link 
                    to="/"
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200 flex items-center justify-center"
                  >
                    <span>Go to Homepage</span>
                    <FaArrowRight className="ml-2" />
                  </Link>
                  <Link 
                    to="/auth/academy"
                    className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors duration-200"
                  >
                    Learn More About Our Academy
                  </Link>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Success; 